import { checkboxAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
   createMultiStyleConfigHelpers(checkboxAnatomy.keys);

const baseStyle = definePartsStyle({
   control: {
      borderColor: "brandBlue.400",
      border: "1px solid",
   },
   label: {
      _disabled: {
         opacity: 1,
      },
   },
});

export const checkboxTheme = defineMultiStyleConfig({ baseStyle });
